import classNames from "classnames";
import { useState } from "react";
import CustomButton from "shared/components/common/customButton";
import BrandListings from "shared/components/dashboard/dashboardListings/brandListings";
import AddBrands from "./add";
import styles from "./style.module.scss";
import EditBrands from "./edit";
import CustomTabs from "shared/components/common/customTabs";
import { BrandTabs } from "shared/utils/constants";

const DashboardAddBrand = () => {
  const [createMode, setCreateMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<string>(BrandTabs[0].value);

  const handleCreateTestimonial = () => {
    setCreateMode(true);
  };

  const handleTabChange = (tabValue: string) => {
    setActiveTab(tabValue);
  };

  return (
    <div className={classNames(styles.sectionContainer)}>
      {createMode ? (
        <AddBrands createMode={createMode} setCreateMode={setCreateMode} />
      ) : editMode ? (
        <EditBrands selectedBrand={selectedBrand} setEditMode={setEditMode} />
      ) : (
        <div className={classNames(styles.header)}>
          <div className="ms-auto w-fit mb-4">
            <CustomButton
              onClick={handleCreateTestimonial}
              title="Add Product Brand"
            />
          </div>
          <CustomTabs
            tabs={BrandTabs}
            fullWidthTabs
            defaultActiveTab={BrandTabs[0].value}
            onTabChange={handleTabChange}
          />
          <div className="mt-4">
            <BrandListings
              setEditMode={setEditMode}
              selectedBrand={selectedBrand}
              setSelectedBrand={setSelectedBrand}
              activeTab={activeTab}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardAddBrand;
